/**
 * Страница ошибки.
 */
export function ErrorPage({ message, onRetry }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 p-4">
      <div className="text-center max-w-md">
        <div className="text-6xl mb-4">😕</div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          Что-то пошло не так
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          {message || 'Не удалось загрузить данные заказа'}
        </p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-xl transition-colors duration-200"
          >
            Попробовать снова
          </button>
        )}
      </div>
    </div>
  );
}
